export default function StepNumber({ n }) {
  return (
    <span
      aria-hidden="true"
      className="pointer-events-none absolute -top-2 right-5 -z-10 select-none text-[40px] font-black leading-none tracking-tighter text-black/[0.06] md:-top-3 md:right-6 md:text-[56px]"
    >
      {String(n).padStart(2, "0")}
    </span>
  );
}
